module.exports = __webpack_public_path__ + "img/product_01_pic@2x.d50a4f95.png";